import { STORE_LIST_ACTION } from "core/constants/Actions";
import { TypedThunk, TypedDispatch } from "App/Store";
import { getStores } from "core/services/Store";

export function getStoreList(params: any): TypedThunk {
  return async (dispatch: TypedDispatch) => {
    dispatch({ type: STORE_LIST_ACTION.REQUEST });
    const apiResponse = await getStores(params);
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: STORE_LIST_ACTION.SUCCESS,
        payload: {
          stores: apiResponse.data.stores,
          count: apiResponse.data.count,
          currentPage : params.page,
        },
      });
    } else {
      dispatch({
        type: STORE_LIST_ACTION.FAILURE,
      });
    }
  };
}
